import ClassicSectionComponent from '@wix/thunderbolt-elements/src/components/ClassicSection/viewer/ClassicSection';
import ClassicSectionController from '@wix/thunderbolt-elements/src/components/ClassicSection/viewer/ClassicSection.controller';


const ClassicSection = {
  component: ClassicSectionComponent,
  controller: ClassicSectionController
};


export const components = {
  ['ClassicSection']: ClassicSection
};

